<template>
    <div class='tops_body' :style="scrollPosition" :class="{ 'back_ground_control' : backGroundControl }">
        <div class="regist-companion-body" :class="bodyClass">
            <h2 class='reserve-accent-title pb-sm-2 bg-single'><span class="align-middle">組合せ登録</span>
            </h2>
            <div :class="{ 'background-white': (index != 0) }" v-for="(registCompanionFrame, index) in companionRegist" :key="registCompanionFrame.id">
                <div v-if="index == 0" class="row mb-1 no-gutters justify-content-sm-start justify-content-between">
                    <div class="col-sm-2 col-5 px-1">
                        <button
                            class='bluebackbutton w-100'
                            v-on:click="OnCompanionList()">同伴者リスト
                        </button>
                    </div>
                    <div class="col-sm-10 col-7 px-1">
                        <div class="row">
                            <span @click="confirmClearDialogSw=true" class="col-12 all-clear text-right bg-single">
                                クリア
                            </span>
                            <span class="col-12 text-right">
                                <input type="checkbox" class='checkbox_size' v-model="sendFlag">
                                <span class="ml-1 bg-single">同伴者に送信する</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="table-back-ground">
                    <div v-if="showCellEdit" class='row font-weight-bold cell-check' :hidden="planId === 0">
                        <div class="col-sm-3 pl-1">
                            <input type="checkbox" class='checkbox_size' :value="registCompanionFrame.cell_id" v-model="deleteCell">
                            <label>組を削除</label>
                        </div>
                    </div>
                    <div class="row companion-table-head-content">
                        <div class='col-sm-auto col-auto font-weight-bold'>{{ registCompanionFrame.id }}組目</div>
                        <div class='col-sm-auto col-auto font-weight-bold' v-if="courseNameDisplay">{{ registCompanionFrame.course_name }}</div>
                        <div class='col-sm-1 col-auto font-weight-bold'>{{ registCompanionFrame.time }}</div>
                    </div>
                    <table class="pcview mb-3 companion-table-body">
                        <thead>
                            <tr class="w-100">
                                <th width="115"></th>
                                <th :width="nameWidth" align="left">お名前</th>
                                <th v-if="mobileNumberDisb" :width="mobileNumberWidth" :class="thMail" align="left">
                                    携帯番号
                                </th>
                                <th v-if="emailDisb" :width="emailWidth" :class="thMail" align="left">
                                    メールアドレス
                                </th>
                                <th v-if="reserveType == reserveTypeShare" width="100" class="profile-col"></th>
                                <th v-if="reserveWeb" width="240" colspan="3">
                                    <!-- <input type="checkbox" class='checkbox_size' id="mobile_number" v-model="sendFlag">
                                    予約内容を同伴者に送信する -->
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(player, playerIndex) in registCompanionFrame.players" :key="player.id">
                                <td>プレーヤー{{ player.id }}</td>
                                <td>
                                    <select
                                        class='w-100 form-control'
                                        :style="player.style"
                                        v-model="player.player_no"
                                        @change="CallSetBindSelectBoxValue(player.player_no, index, playerIndex)"
                                        :disabled="player.selectFlag"
                                        placeholder="選択してください"
                                        autocomplete="off">
                                        <option
                                            v-for="data in player.selectBox"
                                            :key="data.player_no"
                                            :value="data.player_no"
                                        >
                                            <span>{{ data.player_name }}</span>
                                        </option>
                                    </select>
                                </td>
                                <td v-if="mobileNumberDisb">
                                    <input
                                        class='w-100 form-control'
                                        :style="player.style"
                                        type="text"
                                        v-model.trim="player.mobile_number"
                                        disabled>
                                </td>
                                <td v-if="emailDisb">
                                    <input
                                        class='w-100 form-control'
                                        :style="player.style"
                                        type="text"
                                        v-model.trim="player.email"
                                        disabled>
                                </td>
                                <td v-if="reserveType == reserveTypeShare" class="text-center profile-col">
                                    <button
                                        v-if="player.pofileFlag == true"
                                        class='btn btn-sm btn-outline-success companion-profile-button'
                                        v-on:click='OpenInputPlayeDialog(registCompanionFrame.id,player)'
                                        >プロフィール
                                    </button>
                                </td>
                                <td v-if="reserveWeb" class="text-center clear-col">
                                    <button class='btn btn-sm btn-outline-secondary'
                                        v-if="player.displayFlag !== true && reserveWeb"
                                        @click="ClearPlayerData(player, index, playerIndex)"
                                        :disabled="player.clearBtnDisabled">
                                    クリア
                                    </button>
                                </td>
                                <td v-if="reserveWeb" class="text-center regist-col">
                                    <button class='btn btn-sm btn-outline-info'
                                        v-if="player.displayFlag !== true && reserveWeb"
                                        @click="OnAppend(player, registCompanionFrame.id, index, playerIndex)"
                                        :disabled="player.appendBtnDisabled || planId === 0">
                                    席追加
                                    </button>
                                </td>
                                <td v-if="reserveWeb" class="text-center">
                                    <button class='btn btn-sm btn-outline-danger'
                                        v-if="player.displayFlag !== true && reserveWeb"
                                        @click="OnCancel(player, registCompanionFrame.id, index, playerIndex)"
                                        :disabled="player.cancelBtnDisabled || planId === 0">
                                    席削除
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="spview mt-0">
                        <div>
                            <div v-for="(player, playerIndex) in registCompanionFrame.players" :key="player.id" class="my-1">
                                <div class="row justify-content-between">
                                    <!-- <div class="col-5">プレーヤー{{ player.id }}</div> -->
                                    <div v-if="reserveType == reserveTypeShare" class="col-12">
                                        <button
                                            v-if="player.pofileFlag == true"
                                            class='btn btn-sm btn-outline-success companion-profile-button w-100'
                                            v-on:click='OpenInputPlayeDialog(registCompanionFrame.id,player)'
                                        >プロフィール
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <div class="row no-gutters justify-content-around">
                                        <div class="px-1 col-6">
                                            <select
                                                class='companion-form-control'
                                                :style="player.style"
                                                v-model="player.player_no"
                                                @change="CallSetBindSelectBoxValue(player.player_no, index, playerIndex)"
                                                :disabled="player.selectFlag"
                                                autocomplete="off">
                                                <option
                                                    v-for="data in player.selectBox"
                                                    :key="data.player_no"
                                                    :value="data.player_no"
                                                >
                                                    <span>{{ data.player_name }}</span>
                                                </option>
                                                <optgroup disabled></optgroup>
                                            </select>
                                        </div>
                                        <div class="col-6 px-1">
                                            <input
                                                v-if="mobileNumberDisb"
                                                class='companion-form-control'
                                                :style="player.style"
                                                type="text"
                                                v-model.trim="player.mobile_number"
                                                disabled>
                                        </div>
                                        <div class="px-1 col-12">
                                            <input
                                                v-if="emailDisb"
                                                class='companion-form-control'
                                                :style="player.style"
                                                type="text"
                                                v-model.trim="player.email"
                                                disabled>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="reserveWeb" class="row no-gutters justify-content-between mb-3">
                                    <button class='col-4 btn btn-sm btn-outline-secondary'
                                        v-if="player.displayFlag !== true"
                                        @click="ClearPlayerData(player, index, playerIndex)"
                                        :disabled="player.clearBtnDisabled">
                                    クリア
                                    </button>
                                    <button class='col-4 btn btn-sm btn-outline-info'
                                        v-if="player.displayFlag !== true"
                                        @click="OnAppend(player, registCompanionFrame.id, index, playerIndex)"
                                        :disabled="player.appendBtnDisabled || planId === 0">
                                    席追加
                                    </button>
                                    <button class='col-4 btn btn-sm btn-outline-danger'
                                        v-if="player.displayFlag !== true"
                                        @click="OnCancel(player, registCompanionFrame.id, index, playerIndex)"
                                        :disabled="player.cancelBtnDisabled || planId === 0">
                                    席削除
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row-nomargin py-3 justify-content-around">
                <div v-if="showCellEdit && openFlag === '1' && memberOpen === '1'"
                     class="col-sm-3 col-6 px-1"
                     :class="{ 'mt-2 mt-sm-0' : showCellEdit && planId != 0}"
                >
                    <button
                        class="btn nextBtn w-100"
                        @click='OnAddCell'
                        :hidden="planId === 0"
                    >組を追加</button>
                </div>
                <div v-if="mobileAppHidden === false" class="col-sm-3 col-6 px-1" :class="{ 'mt-2 mt-sm-0' : showCellEdit && planId != 0}">
                    <button
                        v-if="showMypageBtn"
                        class='mypagebackbutton w-100'
                        @click="onMypage"
                    >一覧へ戻る</button>
                </div>
                <div class="col-sm-3 col px-1" :class="{ 'mt-2 mt-sm-0' : showCellEdit && planId != 0}">
                    <button
                        class="btn nextBtn w-100"
                        @click='CompleteAccess'
                    >確定</button>
                </div>
            </div>
            <InputPlayerDialogModal ref="InputPlayerDialogView" v-show="showInputPlayerDialog" v-on:from-Dialog="OnCloseInputPlayeDialog" v-on:close-dialog="OnCloseInputPlayerDialog"></InputPlayerDialogModal>
            <ErrorWordingDialogModal v-show="showErrorWordingDialog" v-bind:errorWording="errorWording" v-on:closeErrorDialog="CloseErrorDialog"></ErrorWordingDialogModal>
            <FriendInputModal v-if="inputModal === true" @close="closeEvent" :memberData="member" :editMode="editMode" />
            <ConfirmDialog v-if="confirmDialogSw === true"
                initialMessage="「組を削除」選択時、選択した組のスタート時間が削除されます。よろしいですか？"
                doing="はい"
                notDoing="いいえ"
                :processing="processing"
                @from-Dialog="onConfirmDialogYes"
                @closeBtn="onConfirmDialogNo"
            />
            <ConfirmDialog v-if="confirmClearDialogSw === true"
                initialMessage="全ての組合せをクリアします。よろしいですか？"
                doing="はい"
                notDoing="いいえ"
                :processing="processing"
                @from-Dialog="onConfirmClearDialogYes"
                @closeBtn="onConfirmClearDialogNo"
            />
            <ConfirmDialog v-if="confirmCompleteDialogSw === true"
                initialMessage="登録が完了しました。"
                doing="はい"
                notDoing="いいえ"
                :processing="processing"
                @closeBtn="onCompleteConfirmDialogNo"
            />
        </div>
    </div>
</template>

<script>
import InputPlayerDialogModal from './dialog/InputPlayerDialog';
import SelectCompanionDialogModal from './dialog/SelectCompanionDialog';
import ErrorWordingDialogModal from '../components/ErrorDialog';
import FriendInputModal from '../components/FriendInputModal';
import ConfirmDialog from '../components/ConfirmDialog';
import { CODE_MASTER } from '../../config';
import { GET_RESERVE_COMPANION_SHOW_LIST, REGIST_COMPANION_MAIL_SEND } from '../../constants/companion';
import { UPDATE_COMPANION_MAIL_SEND } from '../../constants/reserve';
import { GET_RESERVE } from '../../constants/mypage_reserves';
// import { GET_PLAY_TOGETHER_FIXED_DEADLINE } from '../../constants/golf_course';
import { modalMixin } from '../../mixins/modal';
import validater from "../../lib/validater";

export default {
    components: {
        InputPlayerDialogModal,
        SelectCompanionDialogModal,
        ErrorWordingDialogModal,
        FriendInputModal,
        ConfirmDialog
    },
    mixins: [modalMixin],
    data () {
        return {
            showSelectFriendDialog: false,
            showSelectCompanionDialog: false,
            showInputPlayerDialog: false,
            showErrorWordingDialog: false,
            inputModal: '',
            member: {
                familyName: '',
                givenName: '',
                email: '',
                mobile_number: ''
            },
            reserveEmailData: [],
            // 同伴者登録の配列
            companionRegist: [],
            // 枠のId
            frameId: null,
            // plan_idが0なら電話予約：予約内容を変更できないようにする
            planId: 0,
            // エラーダイアログに送る文章用
            errorWording: null,
            // 予約番号 (仮 親からもらう予定)
            reserveNo: '',
            // 予約タイプ（仮 親からもらう予定）
            reserveType: null,
            // 予約された最大人数
            maxNumber: null,
            // 予約済み人数
            reservedPeople: null,
            // templete シェア予約用変数
            reserveTypeShare: null,
            // css切り替え用
            thMail: null,
            thClear: null,
            // 予約内容をメールで送信にチェックされたメールアドレス
            reserveInfoEmail: [],
            reserveInfo: [],
            // お友達登録編集に送るよう
            sendPlayer: [],
            // 友達選択画面に送る情報
            friendPlayer: {},
            loginUserMemberNo: null,
            loginUser: {
                email: null,
                mobile_number: null
            },
            play_date: null,
            playDate: null,
            golfName: null,
            courseName: null,
            shareCellId: null,
            changeFlag: null,
            loadingCount: 0,
            // 0:予約時、1:変更(枝番更新前)、2:変更(枝番更新後)
            // editFlag: 0,
            settingNumber: 0,
            representative: null,
            validaterFlag: true,
            showMypageBtn: false,
            showCellEdit: false,
            flagList: [],
            deleteCell: [],
            sendFlag: true,
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            // コンファーム表示識別（組削除）
            confirmDialogSw: false,
            // コンファーム表示識別（組合せクリア）
            confirmClearDialogSw: false,
            // コンファーム表示識別（登録完了）
            confirmCompleteDialogSw: false,
            // 登録完了後の遷移先
            returnUrl: '',
            // コース名の表示用
            courseNameDisplay: true,
            newSw: true,
            // 同伴者リスト
            playerList: [],
            playerNoList: [],
            emailDisb: false,
            mobileNumberDisb: false,
            reserveWeb: false,
            nameWidth: '',
            mobileNumberWidth: '',
            emailWidth: '',
            bodyClass: 'regist-companion-web-reserve-body',
            // モーダル背景スクロール制御フラグ
            backGroundControl: false,
            // 公開、非公開フラグ
            openFlag: '',
            // 会員区分
            memberClass: '',
            // プラン公開区分
            planMemberClass: '',
            // 会員公開フラグ
            memberOpen: '',
            // モバイルアプリ非表示フラグ
            mobileAppHidden: false
        };
    },
    created () {
        this.Initialize();
    },

    watch: {
        deleteCell: function (val) {
            this.companionRegist.map(el => {
                // 削除の場合
                if (val.includes(el.cell_id)){
                    el.cellUpdateType = 2;
                    for (let player of el.players) {
                        // セレクトボックスのクリア処理
                        let playerIndex = Number(player.id) -1;
                        this.ClearPlayerData(player, el.cell_id, playerIndex);
                        player.selectFlag = true;
                        player.clearBtnDisabled = true;
                        player.cancelBtnDisabled = true;
                        player.appendBtnDisabled = true;
                    }
                    for (var i = 0; i < this.reserveInfoEmail.length; i++) {
                        if (this.reserveInfoEmail[i].cell_id == el.cell_id) {
                            this.reserveInfoEmail.splice(i,1);
                        }
                    }
                } else {
                    el.cellUpdateType = 0;
                    this.SetAttribute(el);
                }
            });
        }
    },
    computed: {
        /** ----------------------------------------------
         * placeholder処理
         * ---------------------------------------------- */
        disabledReturnEmpty (disabled, placeholder) {
            return function (disabled, placeholder) {
                return !disabled ? placeholder : '';
            }
        },

    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async Initialize () {
            this.loadingCount = 0;

            // モバイルアプリか判断する
            if (this.$store.state.auth.mobileAppFlag) {
                // モバイルアプリの場合、アプリから送られた予約番号を取得し、遷移ボタンを非表示にする
                this.mobileAppHidden = true;
            }
            this.reserveNo = sessionStorage.getItem('Reserve.reserveNo');
            this.reserveType = sessionStorage.getItem('Reserve.reserveType');
            this.loginUserMemberNo = this.$store.state.auth.loginMember.member_no;


            if (sessionStorage.getItem('MyPage.memberClass')) {
                this.memberClass = sessionStorage.getItem('MyPage.memberClass');
            }
            if (sessionStorage.getItem('MyPage.planMemberClass')) {
                this.planMemberClass = sessionStorage.getItem('MyPage.planMemberClass');
            }

            // 予約者の会員区分とプラン区分を比較し、枠選択に制限をかける
            if (this.planMemberClass.charAt(this.memberClass) === '1') {
                this.memberOpen = 1;
            } else {
                this.memberOpen = 0;
            };

            if (sessionStorage.getItem('MyPage.openFlag')) {
                this.openFlag = sessionStorage.getItem('MyPage.openFlag');
            }

            // 変更の場合
            if (sessionStorage.getItem('MyPage.companionChangeFlg')) {
               this.showMypageBtn = true;
               this.newSw = false;
               // 組変更の場合、枠削除のチェックボックスを表示
               if (sessionStorage.getItem('MyPage.companionChangeFlg') == 2) {
                   this.showCellEdit = true;
               }
            }

            // 同伴者情報取得及び表示設定
            await this.GetReserveCompanionShowList();

            if (this.reserveType == CODE_MASTER.RESERVE_TYPE_SHARE) {

                this.reserveTypeShare = CODE_MASTER.RESERVE_TYPE_SHARE;
                this.thMail= 'th_510';
                if (this.reserveWeb) {
                    if (this.emailDisb && !this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.emailWidth = '260';
                        this.bodyClass = 'regist-companion-1input-share-webreserve-body';
                    } else if (!this.emailDisb && this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.mobileNumberWidth = '260';
                        this.bodyClass = 'regist-companion-1input-share-webreserve-body';
                    } else if (this.emailDisb && this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.mobileNumberWidth = '260';
                        this.emailWidth = '260';
                        this.bodyClass = 'regist-companion-2input-share-webreserve-body';
                    } else {
                        this.nameWidth = '350';
                        this.bodyClass = 'regist-companion-nameonly-share-webreserve-body';
                    }
                } else {
                    if (this.emailDisb && !this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.emailWidth = '260';
                        this.bodyClass = 'regist-companion-1input-share-reserve-body';
                    } else if (!this.emailDisb && this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.mobileNumberWidth = '260';
                        this.bodyClass = 'regist-companion-1input-share-reserve-body';
                    } else if (this.emailDisb && this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.mobileNumberWidth = '260';
                        this.emailWidth = '260';
                        this.bodyClass = 'regist-companion-2input-share-reserve-body';
                    } else {
                        this.nameWidth = '470';
                        this.bodyClass = 'regist-companion-nameonly-share-reserve-body';
                    }
                }

            } else if (this.reserveType == CODE_MASTER.RESERVE_TYPE_NORMAL) {

                this.thMail= 'th_500';
                if (this.reserveWeb) {
                    if (this.emailDisb && !this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.emailWidth = '260';
                        this.bodyClass= 'regist-companion-1input-webreserve-body';
                    } else if (!this.emailDisb && this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.mobileNumberWidth = '260';
                        this.bodyClass = 'regist-companion-1input-webreserve-body';
                    } else if (this.emailDisb && this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.mobileNumberWidth = '260';
                        this.emailWidth = '260';
                        this.bodyClass = 'regist-companion-2input-webreserve-body';
                    } else {
                        this.nameWidth = '350';
                        this.bodyClass = 'regist-companion-nameonly-webreserve-body';
                    }
                } else {
                    if (this.emailDisb && !this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.emailWidth = '260';
                        this.bodyClass = 'regist-companion-1input-reserve-body';
                    } else if (!this.emailDisb && this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.mobileNumberWidth = '260';
                        this.bodyClass = 'regist-companion-1input-reserve-body';
                    } else if (this.emailDisb && this.mobileNumberDisb) {
                        this.nameWidth = '350';
                        this.mobileNumberWidth = '260';
                        this.emailWidth = '260';
                        this.bodyClass = 'regist-companion-2input-reserve-body';
                    } else {
                        this.nameWidth = '600';
                        this.bodyClass = 'regist-companion-nameonly-reserve-body';
                    }
                }
            }
        },
        /** ----------------------------------------------
         * 同伴者情報のセレクトボックスを取得する
         * ---------------------------------------------- */
        MakeSelectBox: async function (playerList) {
            for (let cell of this.companionRegist) {
                for (let player of cell.players) {
                    player.selectBox = [];
                    for (let list of playerList) {
                        player.selectBox.push(list);
                    }
                }
            }
        },
        /** ----------------------------------------------
         * player_noだけの配列を作成する
         * ---------------------------------------------- */
        MakePlayerNoList: async function () {
            var playerList = [];
            for (let cell of this.companionRegist) {
                for (let player of cell.players) {
                    playerList.push(player.player_no);
                }
            }
            return playerList;
        },
        /** ----------------------------------------------
         * クリアボタン押
         * ---------------------------------------------- */
        OnAllClear: async function () {
            for (let cell of this.companionRegist) {
                var count = 0;
                for (let player of cell.players) {
                    if (player.reserve_no == this.reserveNo || !player.reserve_no) {
                        if (cell.cellPlayNumber <= count) {
                            break;
                        }
                        player.selectFlag = false;
                        player.mobile_number = '';
                        player.email = '';
                        player.player_no = 0;
                        player.member_no = null;
                        player.family_name = null;
                        player.given_name = null;
                        player.nickname = null;
                        player.email = null;
                        player.mobile_number = null;
                        player.enthusiasm = null;
                        player.score_level = null;
                        player.profile = null;
                        player.era = null;
                        player.gender = 0;
                        player.member_class = 0;
                        player.old_member_class = 0;
                        player.visited_code = 0;
                        player.org_nickname = null;
                        player.org_score_level = null;
                        player.org_profile = null;
                        player.org_era = null;
                        player.org_gender = 0;
                        player.companion_id = 0;
                        count++;
                    }
                }
            }
            await this.MakeSelectBox(this.playerList);
            var playerNoList = await this.MakePlayerNoList();
            // 選択状況を更新する
            for (var list of this.playerList) {
                if (playerNoList.includes(list.player_no)) {
                    list.selected = true;
                } else {
                    list.selected = false;
                }
            }
        },
        /** ----------------------------------------------
         * 同伴者情報のセレクトボックスを切り替える
         * ---------------------------------------------- */
        BindSelectBox: async function (playerNo, cellIndex, playerIndex) {

            // companionRegistのplayer_noだけの配列データを取得
            var playerNoList = await this.MakePlayerNoList();
            // 選択状況を更新する
            for (var list of this.playerList) {
                if (playerNoList.includes(list.player_no)) {
                    list.selected = true;
                } else {
                    list.selected = false;
                }
            }

            for (var i = 0; i < this.companionRegist.length; i++) {
                for (var j = 0; j < this.companionRegist[i].players.length; j++) {
                    // 変更されたセレクトボックスの場合
                    if (cellIndex == i && playerIndex == j) {
                        // 監視用の同伴者リストで選択されていないもので
                        // 現在のセレクトボックスに無ければプッシュする
                        for (var list of this.playerList) {
                            if (list.selected == false && !this.companionRegist[i].players[j].selectBox.some( b => b.player_no == list.player_no)){
                                this.companionRegist[i].players[j].selectBox.push(list);
                                // player_noの昇順でソートする
                                this.companionRegist[i].players[j].selectBox.sort((a, b) => a.player_no - b.player_no);
                            }
                        }
                    // 変更されていないセレクトボックスの場合
                    } else {
                        for (var k = 0; k < this.companionRegist[i].players[j].selectBox.length; k++) {
                            // 選択されたplayer_noがセレクトボックスにあれば削除
                            if (this.companionRegist[i].players[j].selectBox[k].player_no == playerNo && playerNo != 0) {
                                this.companionRegist[i].players[j].selectBox.splice(k, 1);
                            } else {
                                // 監視用の同伴者リストで選択されていないもので
                                // 現在のセレクトボックスに無ければプッシュする
                                for (var list of this.playerList) {
                                    if (list.selected == false && !this.companionRegist[i].players[j].selectBox.some( b => b.player_no == list.player_no)){
                                        this.companionRegist[i].players[j].selectBox.push(list);
                                        // player_noの昇順でソートする
                                        this.companionRegist[i].players[j].selectBox.sort((a, b) => a.player_no - b.player_no);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
         /** ----------------------------------------------
         * 選択されたSelectBoxの情報をcompanionRegistに設定する
         * ---------------------------------------------- */
        SetBindSelectBoxValue: async function (playerNo, cellIndex, playerIndex) {
            await this.BindSelectBox(playerNo, cellIndex, playerIndex);
            this.companionRegist[cellIndex].players[playerIndex].player_no = playerNo;
            var targetPlayer = this.playerList.find((v) => v.player_no == playerNo);
            // playerNoが0は「選択してください▼」なので
            // 0の場合は情報を削除する
            if (playerNo != 0) {
                this.companionRegist[cellIndex].players[playerIndex].reserve_no = this.reserveNo;
                this.companionRegist[cellIndex].players[playerIndex].mobile_number = targetPlayer.mobile_number;
                this.companionRegist[cellIndex].players[playerIndex].email = targetPlayer.email;
                this.companionRegist[cellIndex].players[playerIndex].member_no = targetPlayer.member_no;
                this.companionRegist[cellIndex].players[playerIndex].family_name = targetPlayer.player_name;
                this.companionRegist[cellIndex].players[playerIndex].given_name = '';
                this.companionRegist[cellIndex].players[playerIndex].nickname = targetPlayer.nickname;
                this.companionRegist[cellIndex].players[playerIndex].enthusiasm = targetPlayer.enthusiasm;
                this.companionRegist[cellIndex].players[playerIndex].score_level = targetPlayer.score_level;
                this.companionRegist[cellIndex].players[playerIndex].profile = targetPlayer.profile;
                this.companionRegist[cellIndex].players[playerIndex].era = targetPlayer.era;
                this.companionRegist[cellIndex].players[playerIndex].gender = targetPlayer.gender;
                this.companionRegist[cellIndex].players[playerIndex].member_class = targetPlayer.member_class;
                this.companionRegist[cellIndex].players[playerIndex].visited_code = targetPlayer.visited_code;
                this.companionRegist[cellIndex].players[playerIndex].companion_id = targetPlayer.companion_id;
            } else {
                this.companionRegist[cellIndex].players[playerIndex].reserve_no = '';
                this.companionRegist[cellIndex].players[playerIndex].mobile_number = '';
                this.companionRegist[cellIndex].players[playerIndex].email = '';
                this.companionRegist[cellIndex].players[playerIndex].member_no = null;
                this.companionRegist[cellIndex].players[playerIndex].family_name = '';
                this.companionRegist[cellIndex].players[playerIndex].given_name = '';
                this.companionRegist[cellIndex].players[playerIndex].nickname = '';
                this.companionRegist[cellIndex].players[playerIndex].enthusiasm = '';
                this.companionRegist[cellIndex].players[playerIndex].score_level = '';
                this.companionRegist[cellIndex].players[playerIndex].profile = '';
                this.companionRegist[cellIndex].players[playerIndex].era = '';
                this.companionRegist[cellIndex].players[playerIndex].gender = 0;
                this.companionRegist[cellIndex].players[playerIndex].member_class = 0;
                this.companionRegist[cellIndex].players[playerIndex].visited_code = 0;
                this.companionRegist[cellIndex].players[playerIndex].companion_id = 0;
            }
        },
         /** ----------------------------------------------
         * SettingValueを取得
         * ---------------------------------------------- */
        CallSetBindSelectBoxValue: async function (playerNo, cellIndex, playerIndex) {
            // × リストから選択された場合のプロフィールデータはマイページで登録されたmembersのデータ(org_xxx)を初期表示する
            // ○ 画面表示時に登録されていたデータで上書きする
            for (var i = 0; i < this.playerList.length; i++) {
                if (this.playerList[i].player_no == playerNo) {
                    this.playerList[i].nickname = this.playerList[i].org_nickname;
                    this.playerList[i].score_level = this.playerList[i].org_score_level;
                    this.playerList[i].profile = this.playerList[i].org_profile;
                    this.playerList[i].era = this.playerList[i].org_era;
                    this.playerList[i].gender = this.playerList[i].org_gender;
                    // プロフィールデータの性別がNull、0なら0(男性)をセットする
                    this.playerList[i].gender = (!this.playerList[i].org_gender) ? 0 : this.playerList[i].org_gender;
                }
            }
            await this.SetBindSelectBoxValue(playerNo, cellIndex, playerIndex);
        },
        /** ----------------------------------------------
         * 予約番号より予約情報と同伴者情報を取得する
         * ---------------------------------------------- */
        GetReserveCompanionShowList: async function () {
            this.loadingOn();
            try {
                let res = await this.$apollo.query({
                        query: GET_RESERVE_COMPANION_SHOW_LIST,
                        fetchPolicy: 'no-cache',
                        variables: {
                            reserve_no: this.reserveNo,
                            member_no: this.loginUserMemberNo
                        }
                });

                // 同伴者変更の場合（他で更新されているかチェックするため変更の場合は予約枝番が設定されている）
                if (sessionStorage.getItem('MyPage.reserveBranchNo')) {
                    const now = res.data.GetReserveCompanionShowList.reserve_branch_no;
                    const previous = sessionStorage.getItem('MyPage.reserveBranchNo');
                    if (now == previous){
                        this.changeFlag = 1;
                    } else if (sessionStorage.getItem('MyPage.companionChangeFlg') == 3) {
                        // スタート時間変更画面からは1にする（branch_noは更新しない）
                        this.changeFlag = 1;
                    } else {
                        // 0だとphp側でエラーになってしまうため
                        this.changeFlag = 9;
                    }
                }

                var reserveCompanions = res.data.GetReserveCompanionShowList.ReserveCompanions;

                // 同伴者変更期限確認
                const today = new Date();
                const playDate = new Date(reserveCompanions[0].play_date);
                const playDateYear = playDate.getFullYear();
                let playDateMonth = playDate.getMonth() + 1;
                let playDateDate = playDate.getDate();
                // 同伴者変更期限日
                var limitDay = new Date(playDateYear, playDateMonth - 1, playDateDate - reserveCompanions[0].play_together_fixed_deadline);
                // 同伴者変更期限日を過ぎていたら画面遷移(99は期限なし)
                if (reserveCompanions[0].play_together_fixed_deadline != 99 && today >= limitDay) {
                    this.$router.push({ path: '/mypage-deadline-companion' });
                    return;
                }

                this.reserveType = reserveCompanions[0].reserve_type;
                this.planId = Number(reserveCompanions[0].plan_id);

                // 表示用同伴者を設定する
                this.sendFlag = Boolean(reserveCompanions[0].send_play_together_email_flag);

                /////////////////////////////////////////////////
                //  入力可能なプレーヤ領域を確保する
                ////////////////////////////////////////////////
                // 新規登録かを判定する
                this.newSw = true;
                for (var i = 0; i < reserveCompanions.length; i++) {
                    // 同伴者データに同一の予約番号が存在する場合
                    if (this.reserveNo == reserveCompanions[i].plt_reserve_no) {
                        this.newSw = false;
                        break;
                    }
                }

                this.playerList = JSON.parse(res.data.GetReserveCompanionShowList.playerList);

                this.companionRegist = JSON.parse(res.data.GetReserveCompanionShowList.companionRegist);

                // コース名表示切替
                if (reserveCompanions[0].display_course === 1) {
                        this.courseNameDisplay = true;
                    } else {
                        this.courseNameDisplay = false;
                    }

                this.emailDisb = Boolean(res.data.GetReserveCompanionShowList.emailDisb);
                this.mobileNumberDisb = Boolean(res.data.GetReserveCompanionShowList.mobileNumberDisb);
                this.reserveWeb = Boolean(res.data.GetReserveCompanionShowList.reserveWeb);
                this.loadingOff();
            } catch (error) {
                this.error = error;
                this.$store.commit("loading/setIsLoading", false);
            }
        },

        /** ----------------------------------------------
         * プレイヤー入力領域の属性を設定
         * @param cellInf 枠情報
         * @param restPlayerCnt 枠のプレーヤー残数
         * ---------------------------------------------- */
        SetAttribute: async function (cellInf) {
            var restCnt = cellInf.playerLeft;
            for (var i = 0; i < 4; i++) {
                // 入力可能なプレーヤ領域の場合
                if (i < cellInf.cellPlayNumber) {
                    cellInf.players[i].selectFlag = false;
                    cellInf.players[i].clearBtnDisabled = false;
                    cellInf.players[i].inputPossibleFlag = true;
                    // 新規登録の場合は追加・キャンセルボタンを非表示
                    if (this.newSw) {
                        cellInf.players[i].cancelBtnDisabled = true;
                        cellInf.players[i].appendBtnDisabled = true;
                    } else {
                        if (cellInf.players[i].member_no) {
                            // 代表者でも変更可能とするためコメントアウト
                            // cellInf.players[i].selectFlag = true;
                        }
                        cellInf.players[i].cancelBtnDisabled = false;
                        cellInf.players[i].appendBtnDisabled = true;
                    }
                    if (this.reserveType == CODE_MASTER.RESERVE_TYPE_SHARE) {
                        cellInf.players[i].pofileFlag = true;
                    }
                } else {
                    // 新規の場合は
                    if (this.newSw) {
                        cellInf.players[i].selectFlag = true;
                        cellInf.players[i].clearBtnDisabled = true;
                        cellInf.players[i].cancelBtnDisabled = true;
                        cellInf.players[i].appendBtnDisabled = true;
                        cellInf.players[i].inputPossibleFlag = false;
                        cellInf.players[i].displayFlag = true;
                    // 変更で通常の場合
                    } else if (this.reserveType == CODE_MASTER.RESERVE_TYPE_NORMAL) {
                        cellInf.players[i].selectFlag = true;
                        cellInf.players[i].clearBtnDisabled = true;
                        cellInf.players[i].cancelBtnDisabled = true;
                        cellInf.players[i].appendBtnDisabled = false;
                        cellInf.players[i].inputPossibleFlag = false;
                    // 変更で空きがある場合
                    } else if (restCnt > 0) {
                        cellInf.players[i].selectFlag = true;
                        cellInf.players[i].clearBtnDisabled = true;
                        cellInf.players[i].cancelBtnDisabled = true;
                        cellInf.players[i].appendBtnDisabled = false;
                        cellInf.players[i].inputPossibleFlag = false;
                        restCnt--;
                    } else {
                        cellInf.players[i].selectFlag = true;
                        cellInf.players[i].clearBtnDisabled = true;
                        cellInf.players[i].cancelBtnDisabled = true;
                        cellInf.players[i].appendBtnDisabled = true;
                        cellInf.players[i].inputPossibleFlag = false;
                        cellInf.players[i].displayFlag = true;
                    }
                }
            }
        },
        /** ----------------------------------------------
         * 同伴者リストを開く
         * ---------------------------------------------- */
        OnCompanionList () {
            this.$router.push({ path: "/companion-list" });
        },
        /** ----------------------------------------------
         * プロフィールボタン押下
         * @startFrameId 何番目に表示されている枠かのID
         * @selectPlayerInfo 編集するプレーヤーの情報
         * ---------------------------------------------- */
        OpenInputPlayeDialog (startFrameId,selectPlayerInfo) {
            this.sendPlayer = selectPlayerInfo;
            this.sendPlayer.startFrameId = startFrameId;
            this.$refs.InputPlayerDialogView.Open(this.sendPlayer);
            this.showInputPlayerDialog = true;
            this.backGroundControl = true;
            this.openModalScroll();
        },
        /** ----------------------------------------------
         * 追加ボタン押下
         * ---------------------------------------------- */
        OnAppend (player, cellNo, cellIndex, playerIndex) {
            var possibleCnt = 0;
            this.companionRegist[cellNo - 1].players.forEach(player => {
                if (player.inputPossibleFlag == true) {
                    possibleCnt++;
                }

            });
            if (this.companionRegist[cellNo - 1].playerMax < possibleCnt + 1) {
                this.showErrorWordingDialog = true;
                this.errorWording = "プレーヤーの数がプランのプレイ人数より多いため追加できません。";
                return;
            }
            this.ClearPlayerData(player, cellIndex, playerIndex);
            player.clearBtnDisabled = false;
            player.cancelBtnDisabled = false;
            player.appendBtnDisabled = true;
            player.inputPossibleFlag = true;
            if (this.reserveType == CODE_MASTER.RESERVE_TYPE_SHARE) {
                player.pofileFlag = true;
            }
        },
        /** ----------------------------------------------
         * キャンセルボタン押下
         * ---------------------------------------------- */
        OnCancel (player, cellNo, cellIndex, playerIndex) {
            var possibleCnt = 0;
            this.companionRegist[cellNo - 1].players.forEach(player => {
                if (player.inputPossibleFlag == true) {
                    possibleCnt++;
                }

            });
            if (this.reserveType == CODE_MASTER.RESERVE_TYPE_NORMAL) {
                if (this.companionRegist[cellNo - 1].playerMin > possibleCnt - 1) {
                    this.showErrorWordingDialog = true;
                    this.errorWording = "プレーヤーの数がプランのプレイ人数より少ないためキャンセルできません。";
                    return;
                }
            }

            this.ClearPlayerData(player, cellIndex, playerIndex);
            // selectFlagはtrueに変更
            player.selectFlag = true;
            player.clearBtnDisabled = true;
            player.cancelBtnDisabled = true;
            player.appendBtnDisabled = false;
            player.inputPossibleFlag = false;
            player.pofileFlag = false;
        },

        /** ----------------------------------------------
         * プロフィール閉じる押
         * ---------------------------------------------- */
        OnCloseInputPlayerDialog () {
            this.showInputPlayerDialog = false;
            this.backGroundControl = false;
            this.closeModalScroll();
            this.$refs.InputPlayerDialogView.scrollChange();
        },
        /** ----------------------------------------------
         * プロフィール登録押
         * @friendInfo お友達登録編集で入力された情報
         * ---------------------------------------------- */
        OnCloseInputPlayeDialog (friendInfo) {
            this.showInputPlayerDialog = false;
            // 編集されたプレーヤー情報の上書き
            for (var i = 0; i < this.companionRegist.length; i++ ) {
                if (this.companionRegist[i].id == friendInfo.startFrameId) {
                    for (var j = 0; j < this.companionRegist[i].players.length; j++) {
                        if (this.companionRegist[i].players[j].id == friendInfo.id) {
                            this.companionRegist[i].players[j].member_no = friendInfo.member_no;
                            this.companionRegist[i].players[j].email = friendInfo.email;
                            this.companionRegist[i].players[j].mobile_number = friendInfo.mobile_number;
                            this.companionRegist[i].players[j].family_name = friendInfo.family_name;
                            this.companionRegist[i].players[j].given_name = friendInfo.given_name;
                            this.companionRegist[i].players[j].nickname = friendInfo.nickname;
                            this.companionRegist[i].players[j].era = friendInfo.era;
                            this.companionRegist[i].players[j].score_level = friendInfo.score_level;
                            this.companionRegist[i].players[j].profile = friendInfo.profile;
                            this.companionRegist[i].players[j].enthusiasm = friendInfo.enthusiasm;
                            this.companionRegist[i].players[j].gender = friendInfo.gender;
                        }
                    }
                }
            }

            // 同伴者リストのプロフィールを更新しておく
            for (var list of this.playerList) {
                if (list.player_no == friendInfo.player_no) {
                    list.gender = friendInfo.gender;
                    list.nickname = friendInfo.nickname;
                    list.era = friendInfo.era;
                    list.score_level = friendInfo.score_level;
                    list.profile = friendInfo.profile;
                    list.enthusiasm = friendInfo.enthusiasm;
                }
            }
        },
        OpenAddtModal () {
            this.editMode = false;
            this.inputModal = !this.inputModal;
        },
        closeEvent () {
            this.inputModal = !this.inputModal;
        },
        /** ----------------------------------------------
         * エラーダイアログを閉じる
         * ---------------------------------------------- */
        CloseErrorDialog () {
            this.showErrorWordingDialog = false;
        },
        /** ----------------------------------------------
         * 同伴者登録、メール送信
         * ---------------------------------------------- */
        RegistCompanionMailSend (data, reserveEmailData, editFlag) {
            this.$apollo.mutate({
                mutation: REGIST_COMPANION_MAIL_SEND,
                variables: {
                    CompanionList: data,
                    ReserveEmail: reserveEmailData,
                    reserveNo: this.reserveNo,
                    editFlag: editFlag
                }
            }).then(res => {
                var result = res.data;
            }).catch(err => {
                this.error = err;
            });
        },
        /** ----------------------------------------------
         * 同伴者入力項目チェック
         * @player 同伴者データ
         * ---------------------------------------------- */
        CheckCompanionValidater: function (player) {
            // メールが入力されているのに性またはお名前が入力されていなかったら
            if (player.email && (!player.family_name && !player.given_name)){
                this.flagList.push(false);
                this.validaterFlag = false;
                this.showErrorWordingDialog = true;
                this.errorWording = this.$t("error.validation.length.nameEmpty");
                return false;
            // メールの正規表現が誤りだったら
            } else if (player.email && !validater.checkMail(player.email)) {
                this.flagList.push(false);
                this.validaterFlag = false;
                this.showErrorWordingDialog = true;
                this.errorWording = this.$t("error.validation.mailFormat");
                return false;
            // 携帯番号の正規表現が誤りだったら
            } else if (player.mobile_number && !validater.checkmobilenumberNoHyphen(player.mobile_number)) {
                this.flagList.push(false);
                this.validaterFlag = false;
                this.showErrorWordingDialog = true;
                this.errorWording = this.$t("error.validation.mobileFormat");
                return false;
            // 問題無ければ（メールは入力されていなくても問題無し）
            } else {
                this.flagList.push(true);
                return true;
            }
        },
        /** ----------------------------------------------
         * 確定ボタン押下
         * ---------------------------------------------- */
        CompleteAccess: function() {
            if (!this.ChcekValidate()) {
                this.showErrorWordingDialog = true;
                return;
            }

            // 削除枠が存在する場合
            if (this.companionRegist.some((item) => item.cellUpdateType == 2) !== false) {
                // 確認ダイアログ表示
                this.confirmDialogSw = true;
            } else {
                // データ登録処理
                this.CallMakeDataCompanionList();
            }
        },
        /** ----------------------------------------------
         * 削除確認で「はい」押下
         * ---------------------------------------------- */
        onConfirmDialogYes: async function () {
            this.onConfirmDialogNo();
            // データ登録処理
            this.CallMakeDataCompanionList();
        },
        /** ----------------------------------------------
         * データ登録処理
         * ---------------------------------------------- */
        CallMakeDataCompanionList: function (){
            // メール送信用オブジェクト作成
            if (sessionStorage.getItem('MyPage.reserveBranchNo')) {
                var editFlag = true;
            } else {
                var editFlag = false;
            }
            var reserveEmailData = [];
            // メール送信フラグがtrueだったら
            if (this.sendFlag) {
                var startTime = [];
                for (let cell of this.companionRegist) {
                    startTime.push(cell.time);
                }
                for (let obj of this.companionRegist) {
                    for (let player of obj.players){
                        // ログインユーザーもメール送信用の配列に入れる
                        if (player.email){
                            let reserveEmailObj = {
                                email: player.email,
                                reserve_no: this.reserveNo,
                                family_name: player.family_name,
                                given_name: player.given_name,
                                start_time: startTime,
                                point: null,
                                edit_flag: editFlag
                            };
                            reserveEmailData.push(reserveEmailObj);
                        }
                    }
                }
            } else {
                var startTime = [];
                let reserveEmailObj = {
                    email: this.companionRegist[0].players[0].email,
                    reserve_no: this.reserveNo,
                    family_name: this.companionRegist[0].players[0].family_name,
                    given_name: this.companionRegist[0].players[0].given_name,
                    start_time: startTime,
                    point: null,
                    edit_flag: editFlag
                };
                reserveEmailData.push(reserveEmailObj);
            }
            // MyPage.reserveBranchNoが存在するなら予約変更画面からの登録
            if (sessionStorage.getItem('MyPage.reserveBranchNo')) {
                this.MakeUpdateCompanionList(reserveEmailData, editFlag);
                this.processing = {
                    result: '1',
                    resultText: '登録が完了しました。',
                    btnDisabled: 0,
                }
                this.returnUrl = sessionStorage.getItem('MyPage.returnBackUrl');
            } else {
                this.MakeRegistCompanionList(reserveEmailData, editFlag);
                this.processing = {
                    result: '1',
                    resultText: '登録が完了しました。予約画面に戻ります。',
                    btnDisabled: 0,
                }
                this.returnUrl = '/reserve';
            }
            // 登録完了ダイアログ表示
            this.confirmCompleteDialogSw = true;
        },
        /** ----------------------------------------------
         * 登録完了画面の閉じる処理で遷移する
         * ---------------------------------------------- */
        onCompleteConfirmDialogNo: function () {
            this.companionRegist = [];
            sessionStorage.removeItem('MyPage.reserveBranchNo');
            sessionStorage.removeItem('Reserve.reserveType');
            sessionStorage.removeItem('Reserve.reserveEdit');
            sessionStorage.removeItem('MyPage.companionChangeFlg');
            sessionStorage.removeItem('MyPage.returnBackUrl');
            sessionStorage.removeItem('MyPage.openFlag');
            sessionStorage.removeItem('MyPage.planMemberClass')
            this.$router.push(this.returnUrl);
        },
        /** ----------------------------------------------
         * 確認ダイアログを非表示
         * ---------------------------------------------- */
        onConfirmDialogNo (data) {
          this.confirmDialogSw = !this.confirmDialogSw;
          this.$set(this.processing, 'result', '');
        },

        /** ----------------------------------------------
         * 組追加ボタン押下
         * ---------------------------------------------- */
        OnAddCell: function() {
            var me = this;
            var reserveInfo = null;
            this.$apollo.query({
                query: GET_RESERVE,
                fetchPolicy: 'no-cache',
                variables: {
                  reserve_no: this.reserveNo
                }
            }).then(res => {
                const data = res.data.GetReserveDetail.Reserve;

                sessionStorage.setItem('Reserve.cellNumber', me.companionRegist.length);
                sessionStorage.setItem('Reserve.groupInfo', JSON.stringify(data.groupInfo));
                sessionStorage.setItem("MyPage.reserveNo", me.reserveNo);
                sessionStorage.setItem("MyPage.golfCode", data.golf_code);
                sessionStorage.setItem('Reserve.cellAdd', true);

                // スタート時間選択画面へ
                this.$router.push({ path: '/starttime' });
            }).catch(error => {
                this.error = error;
            })

        },

        /** ----------------------------------------------
         * 同伴者入力項目チェック
         * ---------------------------------------------- */
        ChcekValidate: function () {
            this.errorWording = null;
            var deleteCnt = 0;
            var cancelCnt = 0;
            var nunberCnt = 0;
            var loginUser = false;
            for (var classIdx = 0; classIdx < this.companionRegist.length; classIdx++) {
                var classItem = this.companionRegist[classIdx];
                // 枠削除の場合
                if (classItem.cellUpdateType == 2) {
                    deleteCnt++;
                    continue;
                }
                cancelCnt = 0;
                for (var playerIdx = 0; playerIdx < classItem.players.length; playerIdx++) {
                    var player = classItem.players[playerIdx];

                    if (player.inputPossibleFlag == false) {
                        cancelCnt++;
                    }
                    if (this.loginUserMemberNo == player.member_no) {
                        loginUser = true;
                    }

                    // 代表者以外のお名前が非活性の場合ノーチェック（無視）
                    if (player.selectFlag && classIdx != 0 && playerIdx != 0){
                        continue;
                    }
                    // メール、携帯番号のみが入力されている場合
                    if ((player.email || player.mobile_number) && (!player.family_name && !player.given_name)){
                        this.errorWording = this.$t("error.validation.length.nameEmpty");
                        return false;
                    }
                    // メールの正規表現誤りの場合
                    if (player.email && !validater.checkMail(player.email)) {
                        this.errorWording = this.$t("error.validation.mailFormat");
                        return false;
                    }
                    // 携帯番号の正規表現誤りの場合
                    if (player.mobile_number && !validater.checkmobilenumberNoHyphen(player.mobile_number)) {
                        this.errorWording = this.$t("error.validation.mobileNumber");
                        return false;
                    }
                    if (player.family_name) {
                        nunberCnt++;
                    }
                }
                if (cancelCnt == classItem.players.length) {
                    this.errorWording = 'プレーヤーがいない組があります。';
                    return false;
                }
            }

            if (deleteCnt == this.companionRegist.length) {
                this.errorWording = '全ての組をキャンセルできません。';
                return false;
            }
            // 代表者が存在しない場合
            // if (!loginUser) {
            //     this.errorWording = '予約者様（代表者様）が入力されていません。';
            //     // '\n予約者様を入力する場合は「同伴者を選ぶ」から選択してください。';
            //     return false;
            // }

            return true;
        },

        /** ----------------------------------------------
         * 新規登録用オブジェクト作成
         * ---------------------------------------------- */
        MakeRegistCompanionList: function (reserveEmailData, editFlag) {
            var data = [];
            // 選択されたプレーヤの情報をミューテーション用の配列に格納する
            for (var i = 0; i < this.companionRegist.length; i++ ) {
                var playerNumberCount = 0;
                // シェア予約の場合予約済みの人数を入れる
                //var id = (this.reserveType == CODE_MASTER.RESERVE_TYPE_SHARE) ? this.reservedPeople : 0 ;
                for (var j = 0; j < this.companionRegist[i].players.length; j++) {
                    // お名前とメールが入力されていてたら
                    if (this.CheckCompanionValidater(this.companionRegist[i].players[j]) &&
                        (this.companionRegist[i].players[j].reserve_no == this.reserveNo ||
                         !this.companionRegist[i].players[j].reserve_no) &&
                         this.companionRegist[i].cellPlayNumber > playerNumberCount) {

                        this.companionRegist[i].players[j].era = (!this.companionRegist[i].players[j].era) ? this.companionRegist[i].players[j].era = null : this.companionRegist[i].players[j].era;
                        this.companionRegist[i].players[j].gender = (!this.companionRegist[i].players[j].gender) ? this.companionRegist[i].players[j].gender = 0 : this.companionRegist[i].players[j].gender;
                        this.companionRegist[i].players[j].nickname = (!this.companionRegist[i].players[j].nickname) ? this.companionRegist[i].players[j].nickname = null : this.companionRegist[i].players[j].nickname;
                        this.companionRegist[i].players[j].score_level = (!this.companionRegist[i].players[j].score_level) ? this.companionRegist[i].players[j].score_level = null : this.companionRegist[i].players[j].score_level;
                        this.companionRegist[i].players[j].profile = (!this.companionRegist[i].players[j].profile) ? this.companionRegist[i].players[j].profile = null : this.companionRegist[i].players[j].profile;
                        this.companionRegist[i].players[j].enthusiasm = (!this.companionRegist[i].players[j].enthusiasm) ? this.companionRegist[i].players[j].enthusiasm = null : this.companionRegist[i].players[j].enthusiasm;
                        //id++;
                        // 同伴者登録用オブジェクト
                        let obj = {
                            reserve_no: this.reserveNo,
                            class_no: this.companionRegist[i].id,
                            player_no: this.companionRegist[i].players[j].id,
                            cell_id: this.companionRegist[i].cell_id,
                            member_no: this.companionRegist[i].players[j].member_no,
                            family_name: this.companionRegist[i].players[j].family_name,
                            given_name: this.companionRegist[i].players[j].given_name,
                            nickname: this.companionRegist[i].players[j].nickname,
                            era: this.companionRegist[i].players[j].era,
                            email: this.companionRegist[i].players[j].email,
                            mobile_number: this.companionRegist[i].players[j].mobile_number,
                            gender: this.companionRegist[i].players[j].gender,
                            score_level: this.companionRegist[i].players[j].score_level,
                            profile: this.companionRegist[i].players[j].profile,
                            enthusiasm: this.companionRegist[i].players[j].enthusiasm,
                            member_class: 0,
                            send_play_together_email_flag: Number(this.sendFlag),
                            visited_code: CODE_MASTER.VISITED_CODE_RESERVE,
                            companion_id: this.companionRegist[i].players[j].companion_id
                        };
                        data.push(obj);
                        playerNumberCount++;
                    }
                }
            }

            var ans = null;
            if (this.reserveType == CODE_MASTER.RESERVE_TYPE_SHARE) {
                ans = this.CheckShareReserve(data);
            } else {
                ans = this.CheckNormalReserve(data);
            }
            if (typeof ans === 'object') {
                this.RegistCompanionMailSend(data, reserveEmailData, editFlag);
            }

        },
        /** ----------------------------------------------
         * 同伴者更新用オブジェクト作成
         * ---------------------------------------------- */
        MakeUpdateCompanionList: function (reserveEmailData, editFlag) {
                this.processing = true;
                let data = [];
                let reserves = [];
                let playerCnt = 0;
                let cellPlayerCnt = 0;
                let cellNumber = 0;
                // 予約人数及び各組毎のプレーヤ数を取得する
                for (let frame of this.companionRegist) {
                    cellPlayerCnt = 0;
                    // 枠削除以外の場合
                    if (frame.cellUpdateType != 2) {
                        for (let player of frame.players) {
                            if (player.inputPossibleFlag == true) {
                                cellPlayerCnt++;
                            }

                        }
                        cellNumber++;
                        playerCnt = playerCnt + cellPlayerCnt;
                        frame.oldCellPlayNumber = frame.cellPlayNumber;
                        frame.cellPlayNumber = cellPlayerCnt;
                    }
                }

                // 設定されたプレーヤ情報を登録・更新用データに設定する
                for (let frame of this.companionRegist) {
                    /*** 組毎の変更情報を設定する ***/
                    // 組が削除されている場合（cell_change_flag 0:変更なし、1:変更、2:削除）
                    if (frame.cellUpdateType == 2) {
                        reserves.push({ reserve_no: this.reserveNo,
                                        player_number: playerCnt,
                                        cell_number: cellNumber,
                                        cell_id: Number(frame.cell_id),
                                        cell_player_number: frame.cellPlayNumber,
                                        cell_change_flag: 2 });
                        continue;
                    // 組の人数が変更されている場合
                    } else if (frame.cellPlayNumber != frame.oldCellPlayNumber) {
                        reserves.push({ reserve_no: this.reserveNo,
                                        player_number: playerCnt,
                                        cell_number: cellNumber,
                                        cell_id: Number(frame.cell_id),
                                        cell_player_number: frame.cellPlayNumber,
                                        cell_change_flag: 1 });
                    } else {
                        reserves.push({ reserve_no: this.reserveNo,
                                        player_number: playerCnt,
                                        cell_number: cellNumber,
                                        cell_id: Number(frame.cell_id),
                                        cell_player_number: frame.cellPlayNumber,
                                        cell_change_flag: 0 });
                    }

                    // 枠セットカウント
                    var frameSetCount = 1;
                    // プレーヤ情報を作成
                    for (let player of frame.players) {
                        // 枠セットカウント数が予約人数を超えたら枠予約人数分のデータはセット済みなのでfor文を繰り上げる
                        if (frameSetCount > frame.cellPlayNumber) {
                            continue;
                        }
                        let obj = {};
                        // 既存プレーヤの場合
                        if (player.reserve_no == this.reserveNo) {
                            obj = {
                                reserve_no: player.reserve_no,
                                cell_id: frame.cell_id,
                                class_no: frame.id,
                                player_no: player.id,
                                family_name: player.family_name,
                                given_name: player.given_name,
                                nickname: player.nickname,
                                email: player.email,
                                mobile_number: player.mobile_number,
                                gender: player.gender,
                                era: player.era,
                                profile: player.profile,
                                score_level: player.score_level,
                                enthusiasm: player.enthusiasm,
                                member_class: player.member_class,
                                visited_code: player.visited_code,
                                member_no: player.member_no,
                                change_flag: this.changeFlag,
                                send_play_together_email_flag: Number(this.sendFlag),
                                reserve_type: this.reserveType,
                                cell_player_number: frame.cellPlayNumber,
                                companion_id: player.companion_id
                            };
                            data.push(obj);
                            // データがセットされたら枠セットカウントをとる
                            frameSetCount++;
                        } else if (player.reserve_no == null || player.reserve_no == '') {
                            obj = {
                                reserve_no: this.reserveNo,
                                cell_id: frame.cell_id,
                                class_no: frame.id,
                                player_no: player.id,
                                family_name: player.family_name,
                                given_name: player.given_name,
                                nickname: player.nickname,
                                email: player.email,
                                mobile_number: player.mobile_number,
                                gender: player.gender,
                                era: player.era,
                                profile: player.profile,
                                score_level: player.score_level,
                                enthusiasm: player.enthusiasm,
                                member_class: player.member_class,
                                visited_code: player.visited_code,
                                member_no: player.member_no,
                                change_flag: this.changeFlag,
                                send_play_together_email_flag: Number(this.sendFlag),
                                reserve_type: this.reserveType,
                                cell_player_number: frame.cellPlayNumber,
                                companion_id: player.companion_id
                            };
                            data.push(obj);
                            // データがセットされたら枠セットカウントをとる
                            frameSetCount++;
                        }
                    }
                }
                this.UpdateCompanionMailSend(data, reserves, reserveEmailData, editFlag);

        },
        /** ----------------------------------------------
         * 通常予約チェック
         * ---------------------------------------------- */
        ClearPlayerData: async function (player, cellIndex, playerIndex) {
            player.family_name = null;
            player.given_name = null;
            player.member_no = null;
            player.email = null;
            player.selectFlag = false;
            player.nickname = null;
            player.email = null;
            player.mobile_number = null;
            player.era = null;
            player.profile = null;
            player.score_level = null;
            player.enthusiasm = null;
            player.visited_code = CODE_MASTER.VISITED_CODE_RESERVE;
            player.member_no = null;
            player.member_class = 0;
            player.old_member_class = 0;
            player.gender = 0;
            player.player_no = 0;
            player.companion_id = 0;
            await this.BindSelectBox(player.player_no, cellIndex, playerIndex);
        },
        /** ----------------------------------------------
         * 通常予約チェック
         * ---------------------------------------------- */
        CheckNormalReserve: function (data) {
            var me = this;
            let object = [];
            let reserves = [];
            let reserveList = [];
            let cells = [];
            var inputNumber = 0;
            var cellPlayerNumber = [];
            // 大元のチェックが駄目であれば
            if (this.flagList.includes(false)){
                this.flagList = [];
                return true;
            }
            this.flagList = [];
            // 予約番号でソートされた配列を作成する
            reserveList = data.reduce((p, x) =>
                (p.indexOf(x.reserve_no) !== -1) ? p : [ ...p, x.reserve_no ], []);
            // 予約番号ごとの人数を数える
            for (var i = 0; i < reserveList.length; i++) {
                reserves.push({ reserve_no: null, player_number: 0 });

                // 作成された更新用オブジェクトと予約番号でソートされた配列の予約番号が一致したら人数をカウントアップする
                for (var j = 0; j < data.length; j++) {
                    if (reserveList[i] === data[j].reserve_no) {
                        reserves[i].reserve_no = data[j].reserve_no;
                        reserves[i].player_number = reserves[i].player_number + 1;
                        if (reserves[i].reserve_no == me.reserveNo) {
                            inputNumber = reserves[i].player_number;
                        }
                    }
                }
            }

            // 予約番号が一致した同伴者だけ作成する
            for (let el of data) {
                if (el.reserve_no == me.reserveNo){
                    object.push(el);
                }
            }

            // 枠ID毎の配列を作る
            cells = data.reduce((p, x) =>
                (p.indexOf(x.cell_id) !== -1) ? p : [ ...p, x.cell_id ], []);
            // 枠毎の人数を数える
            for (var i = 0; i < cells.length; i++) {
                cellPlayerNumber.push(0);
                for (var j = 0; j < data.length; j++) {
                    if (cells[i] === data[j].cell_id) {
                        cellPlayerNumber[i] = cellPlayerNumber[i] + 1;
                    }
                }
            }

            // 最大人数チェック
            let answer = this.CheckMaxNumber(cellPlayerNumber);
            if (answer.result) {
                this.showErrorWordingDialog = true;
                this.errorWording = answer.wording;
                return true;
            }

            // メールアドレス重複チェック
            if (this.DuplicationEmailCheck()) {
                this.showErrorWordingDialog = true;
                this.errorWording = '同じメールアドレスが入力されています';
                return true;
            }
            // 全てのチェックが問題無ければtureを返す
            return {object, reserves};

        },
        /** ----------------------------------------------
         * シェア予約チェック
         * ---------------------------------------------- */
        CheckShareReserve: function (data) {
            var me = this;
            let object = [];
            let reserves = [];
            let reserveList = [];
            let cells = [];
            var inputNumber = 0;
            var cellPlayerNumber = [];
            // 大元のチェックが駄目であれば
            if (this.flagList.includes(false)){
                this.flagList = [];
                return true;
            }
            this.flagList = [];
            // 予約番号でソートされた配列を作成する
            reserveList = data.reduce((p, x) =>
                (p.indexOf(x.reserve_no) !== -1) ? p : [ ...p, x.reserve_no ], []);
            // 予約番号ごとの人数を数える
            for (var i = 0; i < reserveList.length; i++) {
                reserves.push({ reserve_no: null, player_number: 0 });

                // 作成された更新用オブジェクトと予約番号でソートされた配列の予約番号が一致したら人数をカウントアップする
                for (var j = 0; j < data.length; j++) {
                    if (reserveList[i] === data[j].reserve_no) {
                        reserves[i].reserve_no = data[j].reserve_no;
                        reserves[i].player_number = reserves[i].player_number + 1;
                        if (reserves[i].reserve_no == me.reserveNo) {
                            inputNumber = reserves[i].player_number;
                        }
                    }
                }
            }

            // 予約番号が一致した同伴者だけ作成する
            for (let el of data) {
                if (el.reserve_no == this.reserveNo){
                    object.push(el);
                }
            }

            // メールアドレス重複チェック
            if (this.DuplicationEmailCheck()) {
                this.showErrorWordingDialog = true;
                this.errorWording = '同じメールアドレスが使用されています。'
                return true;
            }

            // 携帯番号重複チェック
            if (this.DuplicationMobileCheck()) {
                this.showErrorWordingDialog = true;
                this.errorWording = '同じ携帯番号が使用されています。'
                return true;
            }

            // 全てのチェックが問題無ければtureを返す
            return {object, reserves};
        },
        /** ----------------------------------------------
         * 最大入力人数チェック
         * ---------------------------------------------- */
        CheckMaxNumber: function (data) {
            // 予約人数変更からの遷移の場合
            if (sessionStorage.getItem('MyPage.companionChangeFlg') === '1') {
                // 現在入力されているお名前を計算する。
                let inputs = 0;
                this.companionRegist.forEach(el => {
                    el.players.forEach(val => {
                        if (val.family_name !== '' && val.family_name !== null) {
                            inputs++;
                        }
                    });
                });
                // 最大人数より入力されている人数が大きい場合エラー
                if (this.maxNumber < inputs) {
                    return {
                        result: true,
                        wording: 'この予約の人数は' + this.maxNumber + '名様までとなります。'
                    };
                }
                return {
                    result: false,
                    wording: ''
                };
            // それ以外の場合(通常時の予約等)
            } else {
                for (var i = 0; i < this.companionRegist.length; i++) {
                    if (data[i] > this.companionRegist[i].cellPlayNumber) {
                        return {
                            result: true,
                            wording: this.companionRegist[i].id + '組目の人数は' + this.companionRegist[i].cellPlayNumber + '名様までとなります。'
                        };
                    }
                }
                return {
                    result: false,
                    wording: ''
                };
            }
        },
        /** ----------------------------------------------
         * メールアドレス重複していないかチェック
         * ---------------------------------------------- */
        DuplicationEmailCheck(){
            let s = [];
            for (let i = 0; i < this.companionRegist.length; i++ ) {
                for (let j = 0; j < this.companionRegist[i].players.length; j++) {
                    // 空文字,nullの場合はスルー
                    if (this.companionRegist[i].players[j].email) {
                        s.push(this.companionRegist[i].players[j].email);
                    }
                }
            }
            let d = new Set(s);
            return d.size != s.length;
        },
        /** ----------------------------------------------
         * 携帯番号重複していないかチェック
         * ---------------------------------------------- */
        DuplicationMobileCheck(){
            let s = [];
            for (let i = 0; i < this.companionRegist.length; i++ ) {
                for (let j = 0; j < this.companionRegist[i].players.length; j++) {
                    // 空文字,nullの場合はスルー
                    if (this.companionRegist[i].players[j].mobile_number) {
                        s.push(this.companionRegist[i].players[j].mobile_number);
                    }
                }
            }
            let d = new Set(s);
            return d.size != s.length;
        },
        /** ----------------------------------------------
         * 同伴者登録
         * @data 同伴者データ
         * @reserves 予約番号のリスト{reserve_no:予約番号,number:人数}
         * ---------------------------------------------- */
        UpdateCompanionMailSend: function (data, reserves, reserveEmailData, editFlag) {
            this.$apollo.mutate({
                mutation: UPDATE_COMPANION_MAIL_SEND,
                variables: {
                    CompanionList: data,
                    ReserveNumbers: reserves,
                    ReserveEmail: reserveEmailData,
                    reserveNo: this.reserveNo,
                    editFlag: Number(editFlag)
                }
            }).then(res => {
                var result = res.data;
            }).catch(err => {
                // エラーダイアログ表示
                this.showErrorWordingDialog = true;
                this.errorWording = '同伴者の登録に失敗しました。'
                this.error = err;
            });
        },
        RetrunBtn: function () {
            sessionStorage.removeItem('Reserve.reserveType');
            sessionStorage.removeItem('Reserve.reserveEdit');
            sessionStorage.removeItem('Reserve.reserveNumber');
            this.$router.push(sessionStorage.getItem('Reserve.returnUrl'));
            sessionStorage.removeItem('Reserve.returnUrl');
            sessionStorage.removeItem('MyPage.companionChangeFlg');
        },
        /** ----------------------------------------------
         * クリア確認で「はい」押下
         * ---------------------------------------------- */
        onConfirmClearDialogYes: function () {
            this.OnAllClear();
            this.confirmClearDialogSw = false;
        },
        /** ----------------------------------------------
         * クリア確認で「いいえ」押下
         * ---------------------------------------------- */
        onConfirmClearDialogNo: async function () {
          this.confirmClearDialogSw = !this.confirmClearDialogSw;
          this.$set(this.processing, 'result', '');
        },
        /** ----------------------------------------------
         * マイページに戻る
         * ---------------------------------------------- */
        onMypage: function () {
            sessionStorage.removeItem('MyPage.companionChangeFlg');
            sessionStorage.removeItem('MyPage.openFlag');
            sessionStorage.removeItem('MyPage.planMemberClass')
            this.$router.push('/mypage-reserve-list');
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function (){
            this.loadingCount++;
            this.$store.commit("loading/setIsLoading", true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function (){
            this.loadingCount--;
            if (this.loadingCount == 0) {
                this.$store.commit("loading/setIsLoading", false);
            }
        },

    }
}

</script>

<style scoped>
.regist-companion-web-reserve-body {
    padding-top: 20px;
    width: 1200px;
    margin: 0 auto;
}

/* Web予約なし 通常予約 */
.regist-companion-1input-reserve-body {
    padding-top: 20px;
    width: 750px;
    margin: 0 auto;
}
.regist-companion-2input-reserve-body{
    padding-top: 20px;
    width: 910px;
    margin: 0 auto;
}
.regist-companion-nameonly-reserve-body{
    padding-top: 20px;
    width: 700px;
    margin: 0 auto;
}


/* Web予約あり 通常予約 */
.regist-companion-2input-webreserve-body{
    padding-top: 20px;
    width: 1250px;
    margin: 0 auto;
}
.regist-companion-1input-webreserve-body{
    padding-top: 20px;
    width: 950px;
    margin: 0 auto;
}
.regist-companion-nameonly-webreserve-body{
    padding-top: 20px;
    width: 700px;
    margin: 0 auto;
}


/* Web予約なし 組み合わせ予約 */
.regist-companion-1input-share-reserve-body{
    padding-top: 20px;
    width: 860px;
    margin: 0 auto;
}
.regist-companion-2input-share-reserve-body{
    padding-top: 20px;
    width: 1120px;
    margin: 0 auto;
}
.regist-companion-nameonly-share-reserve-body{
    padding-top: 20px;
    width: 700px;
    margin: 0 auto;
}



/* Web予約あり 組み合わせ予約 */
.regist-companion-2input-share-webreserve-body{
    padding-top: 20px;
    width: 1320px;
    margin: 0 auto;
}
.regist-companion-1input-share-webreserve-body{
    padding-top: 20px;
    width: 1060px;
    margin: 0 auto;
}
.regist-companion-nameonly-share-webreserve-body{
    padding-top: 20px;
    width: 800px;
    margin: 0 auto;
}
.th_400{
    width: 400px;
}
.th_80{
    width: 80px;
}
.th_70{
    width: 70px;
}
.return{
    float: right;
    text-decoration: underline;
    font-size: 0.9rem;
    cursor: pointer;
    color: #207474;
}
.return:hover{
    color: blue;
}
.cell-check{
    font-size: 1.5rem;
}
.companion-form-control {
    display: block;
    width: 100%;
    height: 1.8rem;
    /* padding: 0.375rem 0.75rem; */
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.companion-form-control:disabled{
    background-color: #e9ecef;
    opacity: 1;
}
.row-nomargin{
    display: flex;
    flex-wrap: wrap;
}
.nextBtn {
    height: 40px;
    font-size: 1rem;
}
.table-back-ground {
    padding: 0.1px 15px 0.1px 15px;
}
.background-white{
    background-color: #ffffff;
}
.all-clear{
    text-decoration: underline;
    cursor: pointer;
}
@media screen and (max-width: 896px) {
    .regist-companion-body {
        margin-bottom: 100px;
    }

    .regist-companion-web-reserve-body {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }

    /* Web予約なし 通常予約 */
    .regist-companion-1input-reserve-body {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .regist-companion-2input-reserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .regist-companion-nameonly-reserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }


    /* Web予約あり 通常予約 */
    .regist-companion-2input-webreserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .regist-companion-1input-webreserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .regist-companion-nameonly-webreserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }

    /* Web予約なし 組み合わせ予約 */
    .regist-companion-1input-share-reserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .regist-companion-2input-share-reserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .regist-companion-nameonly-share-reserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }


    /* Web予約あり 組み合わせ予約 */
    .regist-companion-2input-share-webreserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .regist-companion-1input-share-webreserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .regist-companion-nameonly-share-webreserve-body{
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
}
</style>
